import { IconConfig } from "../types";

export const banknote:IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 24 24",
  elements: [
    {
      type: 'rect',
      width: 20,
      height: 12,
      x: 2,
      y: 6,
      rx: 2,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    {
      type: 'circle',
      cx: 12,
      cy: 12,
      r: 2,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    {
      type: 'path',
      d: "M6 12h.01M18 12h.01",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ]
}
